"use client";

import React from "react";
import Script from "next/script";

export default function Callrail() {
  return (
    <Script
      id="callrail-script"
      data-testid="callrail-script"
      src="https://cdn.callrail.com/companies/450534461/12275663641cf8ffd07c/12/swap.js"
      strategy="afterInteractive"
      onReady={() => {
        if (
          window.CallTrkSwap &&
          typeof window.CallTrkSwap.startSwaps === "function"
        ) {
          window.CallTrkSwap.startSwaps();
        }
      }}
    ></Script>
  );
}
